(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initTasks(root) {
    var filters = root.querySelectorAll('[data-eb-mg-filter]');
    var items = root.querySelectorAll('[data-eb-mg-item]');
    if (!filters.length || !items.length) return;

    filters.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var cat = btn.getAttribute('data-eb-mg-filter');

        filters.forEach(function (f) {
          var active = f === btn;
          f.classList.toggle('is-active', active);
          f.setAttribute('aria-pressed', active ? 'true' : 'false');
        });

        items.forEach(function (item) {
          var match = cat === '__all__' || item.getAttribute('data-eb-mg-cat') === cat;
          item.hidden = !match;
        });
      });
    });
  }

  function closePanel(panel, icon, q) {
    if (reduceMotion) {
      panel.hidden = true;
    } else {
      panel.style.height = panel.scrollHeight + 'px';
      requestAnimationFrame(function () {
        panel.style.height = '0px';
      });
      panel.addEventListener('transitionend', function handler() {
        panel.hidden = true;
        panel.style.height = '';
        panel.removeEventListener('transitionend', handler);
      });
    }
    q.classList.remove('is-open');
    icon.setAttribute('aria-expanded', 'false');
  }

  function openPanel(panel, icon, q) {
    panel.hidden = false;
    if (!reduceMotion) {
      panel.style.height = '0px';
      requestAnimationFrame(function () {
        panel.style.height = panel.scrollHeight + 'px';
      });
      panel.addEventListener('transitionend', function handler() {
        panel.style.height = '';
        panel.removeEventListener('transitionend', handler);
      });
    }
    q.classList.add('is-open');
    icon.setAttribute('aria-expanded', 'true');
  }

  function initAccordion(root) {
    var acc = root.querySelector('[data-eb-mg-acc]');
    if (!acc) return;
    var questions = acc.querySelectorAll('[data-eb-mg-q]');

    questions.forEach(function (q) {
      var trigger = q.querySelector('.eb-mg__qh');
      var panel = q.querySelector('.eb-mg__a');
      if (!trigger || !panel) return;

      trigger.addEventListener('click', function () {
        var isOpen = q.classList.contains('is-open');
        if (isOpen) {
          closePanel(panel, trigger, q);
        } else {
          openPanel(panel, trigger, q);
        }
      });
    });
  }

  function initTorqueSwitch(root) {
    var group = root.querySelector('[data-eb-mg-torque]');
    if (!group) return;
    var tabs = group.querySelectorAll('[data-eb-mg-tab]');
    var panels = group.querySelectorAll('[data-eb-mg-panel]');
    if (!tabs.length) return;

    tabs.forEach(function (tab) {
      tab.addEventListener('click', function () {
        var id = tab.getAttribute('data-eb-mg-tab');

        tabs.forEach(function (t) {
          var active = t === tab;
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-selected', active ? 'true' : 'false');
        });

        panels.forEach(function (panel) {
          panel.hidden = panel.getAttribute('data-eb-mg-panel') !== id;
        });
      });
    });
  }

  function init(root) {
    initTasks(root);
    initAccordion(root);
    initTorqueSwitch(root);
  }

  function boot() {
    document.querySelectorAll('.eb-mg').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    var section = e.target.querySelector('.eb-mg');
    if (section) init(section);
  });
})();
